export enum ERROR {
  UNAUTHORIZED = 'Unauthorized',
}
